export const statusConstants = {
    SET_LOADING: "SET_LOADING",
    SET_SUCCESS: "SET_SUCCESS",
    SET_MESSAGE: "SET_MESSAGE"
}